import React, { useEffect, useRef, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import { useParams } from 'react-router-dom';
import { useToast } from '../../controls/Toast/ToastService';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { GetPatientInTheCabin, GetPatientWhoNext, } from '../../../configurations/crud/opdRegisteredCrud';
import { FaCircleInfo } from 'react-icons/fa6';
import { MdErrorOutline } from 'react-icons/md';
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo';
import { LIVE_URL } from '../../../configurations/initUrls';
import { GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus';
import * as opdCentersCrud from '../../../configurations/crud/opdCentersCrud'
import { isDisabled } from '@testing-library/user-event/dist/utils';
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import LoadingContainer from '../../controls/LoadingContainer';
import StatusContainer from '../../controls/StatusContainer';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import { allowSleep, keepAwake } from '../../../configurations/native/screenTime'
import { useKeepAwake } from 'react-keep-awake';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import moment from 'moment';

export default function Display() {
  const { start, end } = useGlobalLoader()
  const [opdCenters, setOpdCenter] = useState([]);
  const [loding, setLoding] = useState(false);
  const toast = useToast();
  const { centerid } = useParams()
  const [doctorStatus, setDoctorStatus] = useState(1);
  const loginInfo = getLoginInfo()
  const [centerData, setCenterData] = useState();
  const [currentData, setCurrentData] = useState();
  const [nextPatientData, setNextPatientData] = useState();
  const [today, setToday] = useState(new Date());


  const audioRef = useRef(null);
  useKeepAwake()
  useEffect(() => {
    keepAwake()
    return () => {
      allowSleep()
    }
  }, [])
  const ringBell = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((err) => {
        console.error("Playback failed:", err);
      });
    }
  };

  ///Chat Start Block\
  const [connection, setConnection] = useState();
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const joinroom = async (user, room) => {
    try {
      const connection = new HubConnectionBuilder()
        .withUrl(LIVE_URL)
        .configureLogging(LogLevel.Information)
        .build();

      connection.on("UsersInRoom", (users) => {
        setUsers(users);
      });

      connection.on("ReceiveMessage", (user, message) => {
        console.log(message)
        switch (message) {
          case "1": { GetCenterDetails(); break; }
          case "2": {
            GetPatientInTheCabin(); GetPatientWhoNext(); break;
          }
          case "3": {
            GetPatientInTheCabin(); GetPatientWhoNext(); break;
          }
          case "4": {
            GetPatientInTheCabin(); GetPatientWhoNext(); break;
          }
          case "5": {
            ringBell(); break;
          }
        }
        setMessages(messages => [...messages, { user, message }]);
      });

      connection.onclose(e => {
        setConnection();
        setMessages([]);
        setUsers([]);
      })

      connection.onclose(e => {
        setConnection();
        setMessages([]);
      });

      await connection.start();
      await connection.invoke("JoinRoom", { user, room });
      setConnection(connection);

    } catch (e) {
      console.log(e);
    }
  }

  const sendMessage = async (message) => {
    try {
      await connection.invoke("SendMessage", message);
    } catch (e) {
      console.log(e);
    }
  }

  const closeConnection = async () => {
    try {
      await connection.stop();
    } catch (e) {
      console.log(e);
    }
  }

  ///Chat End Block

  useEffect(() => {
    joinroom(loginInfo.userName + "_" + centerid + "_Display", loginInfo.userName + "_" + centerid)
    GetCenterDetails()
    GetPatientInTheCabin()
    GetPatientWhoNext()

    let myInterval = setInterval(() => {
      setToday(new Date())
    }, 1000);

    return () => clearInterval(myInterval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const GetPatientInTheCabin = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetPatientInTheCabin({
      DoctorId: loginInfo.doctorId,
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
      } else {
        setCurrentData()
        // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setCurrentData()
      // toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    })
  }
  const GetPatientWhoNext = () => {
    setLoding(true)
    start()
    try {
      opdRegisteredCrud.GetPatientWhoNext({
        DoctorId: loginInfo.doctorId,
        CenterId: centerid
      }).then(res => {
        let mdata = res.data
        if (mdata.result.succeeded) {
          setNextPatientData(mdata.data)
        } else {
          setNextPatientData()
          // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        }
        setLoding(false)
        end()
      }).catch(errors => {
        setNextPatientData()
        // toast.open(errors, <MdErrorOutline />, "danger")
        setLoding(false)
        end()
      })
    }
    catch (error) {
      alert(error)
    }
  }
  const GetCenterDetails = () => {
    setLoding(true);
    start()
    opdCentersCrud.GetById(centerid)
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setDoctorStatus(mdata.data.doctorStatus)
          setCenterData(mdata.data);
        } else {
          setCenterData();
          // toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setCenterData();
        // toast.open(errors, <MdErrorOutline />, "danger");
        setLoding(false);
        end()
      });
  }

  // shared patient block (used for current + next)
  const PatientBody = ({ data }) => (
    <>
      <div className="text-3xl font-bold leading-tight sm:text-5xl">{data.patientName}</div>
      <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xl sm:text-2xl">
        <span className="opacity-80">Number:</span>
        <span className="text-4xl font-extrabold sm:text-6xl">{data.confirmedAllotedNumber}</span>
        {data.confirmedAllotedNumber != data.opdNumberAlloted &&
          <span className="text-base font-normal opacity-70">/{data.opdNumberAlloted}</span>}
        <StatusContainer bg={ETypeBg(data.type)} text={GetETypeName(data.type)} />
      </div>
      <div className="mt-3 text-base opacity-80 sm:text-lg">
        Ref No. {data.id}{data.registeredIdForRef && "/" + data.registeredIdForRef}
      </div>
    </>
  )

  return (
    <Container>
      <div className="flex flex-col items-center">
        <audio
          ref={audioRef}
          src="/assets/audio/mixkit-cartoon-door-melodic-bell-110.wav"
          preload="auto"
        />
      </div>

      <div className="flex w-full flex-col px-2 sm:px-4">

        {/* ===== Header ===== */}
        <Card
          isBorder={true}
          isBack={true}
          bgColor="bg-[#E6F0FF]"
          borderColor="border-[#4682B4]"
          title={
            <div className="flex w-full flex-col items-center justify-between gap-1 sm:flex-row">
              <span className="font-semibold">Today: {moment(new Date()).format("DD/MM/YYYY")}</span>
              <span className="font-mono text-lg font-bold tracking-wide">{moment(today).format("LTS")}</span>
            </div>
          }
        >
          {/* doctor status indicator (display only) */}
          <div className="flex justify-center sm:justify-end">
            <div className="inline-flex overflow-hidden rounded-lg shadow-sm">
              <span className={`px-4 py-2 text-sm font-semibold text-white transition ${doctorStatus == 1 ? "bg-green-500" : "bg-gray-400"}`}>In The Cabin</span>
              <span className={`px-4 py-2 text-sm font-medium text-white transition ${doctorStatus == 4 ? "bg-orange-500" : "bg-gray-400"}`}>On Rest</span>
              <span className={`px-4 py-2 text-sm font-semibold text-white transition ${doctorStatus == 0 ? "bg-red-500" : "bg-gray-400"}`}>Offline</span>
            </div>
          </div>

          {/* center info */}
          {centerData &&
            <div className="mt-4 flex flex-col items-center text-center text-gray-800">
              <div className="text-3xl font-bold sm:text-5xl">{centerData.centerName}</div>
              <span className="mt-1 text-lg font-normal text-gray-600 sm:text-xl">
                Opd Time: {moment(centerData.opdStartTime).format("LT")}-{moment(centerData.opdEndTime).format("LT")}
              </span>
              <div className="mt-1 text-xl text-gray-600 sm:text-3xl">{centerData.address}</div>
            </div>
          }
        </Card>

        <div className="my-4" />

        {/* ===== Patients ===== */}
        <div className={`grid grid-cols-1 gap-4 ${nextPatientData ? "md:grid-cols-2" : ""}`}>

          {/* current */}
          <Card isBorder={true} bgColor="bg-amber-50" borderColor="border-[#FF8C00]">
            {loding ? (
              <LoadingContainer text="Please wait..." />
            ) : (
              <div className="py-6 text-center text-[#7A4C00]">
                {currentData ? (
                  <>
                    <div className="text-sm font-semibold uppercase tracking-wide opacity-70 sm:text-lg">Patient In The Cabin</div>
                    <div className="mt-3"><PatientBody data={currentData} /></div>
                  </>
                ) : (
                  <div className="py-10 text-2xl font-semibold">OPD Not Started</div>
                )}
              </div>
            )}
          </Card>

          {/* next */}
          {nextPatientData &&
            <Card isBorder={true} bgColor="bg-brand-500" borderColor="border-green-500">
              {loding ? (
                <LoadingContainer text="Please wait..." />
              ) : (
                <div className="py-6 text-center text-white">
                  <div className="text-sm font-bold uppercase tracking-wide opacity-90 sm:text-lg">Next Patient</div>
                  <div className="mt-3"><PatientBody data={nextPatientData} /></div>
                </div>
              )}
            </Card>
          }
        </div>
      </div>
    </Container>
  )
}